export default Object.freeze({
  AUTHENTICATION_FAIL: 'AUTHENTICATION_FAIL',
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
  REQUEST_NEW_PASS_SUCCESS: 'REQUEST_NEW_PASS_SUCCESS',
  REQUEST_NEW_PASS_FAIL: 'REQUEST_NEW_PASS_FAIL',
  STATUS_SUCCESS: 'STATUS_SUCCESS',
  STATUS_FAIL: 'STATUS_FAIL',
  LOG_OUT: 'LOG_OUT',
});
